var _rect, _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_739_88627)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0.5)",
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_739_88627)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 9.58333,
    stroke: "#4848F7",
    strokeWidth: 0.833333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_739_88627",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 16,
    height: 15
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 7.5,
    fill: "#141414"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_739_88627)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 8.625C1.20556 8.625 2.3669 9.07906 3.25276 9.89678L4.49339 11.042C6.07373 12.5008 8.5096 12.5008 10.0899 11.042C11.5939 9.65374 13.8882 9.57799 15.4804 10.864L16.6664 11.8219C17.6102 12.5842 18.7868 13 20 13V18H0V8.625Z",
    fill: "#4848F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.75H0.398805C1.37134 11.75 2.3323 11.5389 3.21533 11.1314L4.66145 10.4639C6.25365 9.72908 8.13172 10.0254 9.42028 11.2149C11.2193 12.8755 14.0355 12.7187 15.639 10.8685L16.897 9.41692C17.6769 8.517 18.8091 8 20 8V18H0V11.75Z",
    fill: "#4848F7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_739_88627"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_88627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_739_88627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_739_88627",
    width: 1,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUpdate);
export default __webpack_public_path__ + "static/media/status_update.f700b37382fba7df9316b9d616949da7.svg";
export { ForwardRef as ReactComponent };